import { schema, t } from '@colyseus/schema'

/** Party statuses (ARCHITECTURE §5.5, D-040). */
export const PARTY_STATUSES = ['idle', 'queueing', 'racing'] as const
export type PartyStatus = (typeof PARTY_STATUSES)[number]

/** One member of a party, in join order. */
export const PartyMemberSchema = schema(
  {
    sessionId: t.string().default(''),
    displayName: t.string().default(''),
    /** False while the member's party connection is in its reconnect window. */
    connected: t.boolean().default(true),
  },
  'PartyMemberSchema',
)
export type PartyMemberSchema = InstanceType<typeof PartyMemberSchema>

/**
 * Room state for `party` (PHASE2 T2.7, D-040): up to 4 friends who queue public races together.
 * `idle` → (leader `"queue"`) `queueing` → (every member got a `"seat"`) `racing`; the leader's
 * next `"queue"` (Play Again) queues again, `"cancel"` goes back to `idle`.
 */
export const PartyState = schema(
  {
    /** Share code (same namespace as private race codes). */
    code: t.string().default(''),
    /** The member allowed to send `"queue"` and `"cancel"`. */
    leaderSessionId: t.string().default(''),
    status: t.string<PartyStatus>().default('idle'),
    members: t.array(PartyMemberSchema),
  },
  'PartyState',
)
export type PartyState = InstanceType<typeof PartyState>
